import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = ['pagination']
  static values = {
    loading: { type: Boolean, default: false },
    rootMargin: { type: String, default: '800px' }
  }

  initialize () {
    const options = {
      rootMargin: this.rootMarginValue
    }

    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options)
  }

  connect () {
    this.intersectionObserver.observe(this.paginationTarget)
  }

  disconnect () {
    this.intersectionObserver.unobserve(this.paginationTarget)
  }

  processIntersectionEntries (entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (this.loadingValue) return
        this.loadNext()
      }
    })
  }

  async loadNext () {
    this.loadingValue = true
    const nextLink = this.paginationTarget.querySelector('a')

    if (nextLink == null) {
      return
    }

    const request = new FetchRequest('get', nextLink.href, { responseKind: 'turbo-stream' })
    const response = await request.perform()

    if (response.ok) {
      this.loadingValue = false
    }
  }
}
